import { 
        dataProps, 
        timingListProps, 
        eStoreTopProps, 
        eStoreSocialMediaProps, 
        eStoreAboutUsProps, 
        eStoreShipmentMethodProp,
        eStoreBannersProp,
        eStoreImprintProp } from './properties'

export const setShopList = (state, payload) => {
    state.list = payload
}  

export const setShopData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.shop_timing_list.length === 0) {
        state.props.shop_timing_list = [JSON.parse(JSON.stringify(timingListProps))]
    } else if(payload.copy) {
        state.props.shop_timing_list.forEach(element => {
            element.id = 0
        })
    }
    if(state.props.e_store_menu_top_list === null || state.props.e_store_menu_top_list.length === 0) {
        state.props.e_store_menu_top_list = [JSON.parse(JSON.stringify(eStoreTopProps))]
    }
    if(state.props.e_store_menu_bottom_list === null || state.props.e_store_menu_bottom_list.length === 0) {
        state.props.e_store_menu_bottom_list = [JSON.parse(JSON.stringify(eStoreTopProps))]
    }
    if(state.props.e_store_social_media_link_list === null || state.props.e_store_social_media_link_list.length === 0) {
        state.props.e_store_social_media_link_list = JSON.parse(JSON.stringify(eStoreSocialMediaProps))
    }

    if(state.props.e_store_shipment_method_list === null || state.props.e_store_shipment_method_list.length === 0) {
        state.props.e_store_shipment_method_list = [JSON.parse(JSON.stringify(eStoreShipmentMethodProp))]
    }
    
    if(state.props.e_store_banners === null || state.props.e_store_banners.length === 0) {
        state.props.e_store_banners = JSON.parse(JSON.stringify(eStoreBannersProp))
    }
    
    if(state.props.e_store_about_us === null) {
        state.props.e_store_about_us = JSON.parse(JSON.stringify(eStoreAboutUsProps))
    }
    
    if(state.props.e_store_imprint === null || state.props.e_store_imprint.length === 0) {
        state.props.e_store_imprint =[ JSON.parse(JSON.stringify(eStoreImprintProp))]
    }
    
    let key = 0
    state.props.shop_timing_list.forEach(element => {
        element.key = key
        key ++
    })

    let privacyPolicy = '<section class="py-5">\n'
        +'<div class="container">	 \n\n'


        +'<p class="heading-3">Heading</p>\n\n'
        +'<p class="content-text-small">Content Here</p>\n\n'
        +'</div>\n'
        +'</section>'

    if(state.props.e_store_privacy_policy === null || state.props.e_store_privacy_policy.length === 0) {
        state.props.e_store_privacy_policy = privacyPolicy
    }

    if(state.props.e_store_cancellation_policy === null || state.props.e_store_cancellation_policy.length === 0) {
        state.props.e_store_cancellation_policy = privacyPolicy
    }

    if(state.props.e_store_job_opening === null || state.props.e_store_job_opening.length === 0) {
        state.props.e_store_job_opening = privacyPolicy
    }

} 

export const addNewShopTimingRow = state => {

    let key = 0
    state.props.shop_timing_list.push(JSON.parse(JSON.stringify(timingListProps)))

    state.props.shop_timing_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('day_name_'+(key-1)).focus()
    }, 300);

}

export const removeShopTimingRow = (state, payload) => {

    let key = 0

    state.props.deleted_timing_items.push(state.props.shop_timing_list[payload])

    state.props.shop_timing_list.splice(payload, 1)

    if(state.props.shop_timing_list.length === 0) {
        state.props.shop_timing_list = [JSON.parse(JSON.stringify(timingListProps))]
    }

    state.props.shop_timing_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const addEStoreTopMenuRow = state => {

    let key = 0
    state.props.e_store_menu_top_list.push(JSON.parse(JSON.stringify(eStoreTopProps)))

    state.props.e_store_menu_top_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeEStoreTopMenuRow = (state, payload) => {

    let key = 0

    state.props.e_store_menu_top_list.splice(payload, 1)

    if(state.props.e_store_menu_top_list.length === 0) {
        state.props.e_store_menu_top_list = [JSON.parse(JSON.stringify(eStoreTopProps))]
    }

    state.props.e_store_menu_top_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const addEStoreGeneralSettingRow = state => {

    let key = 0
    state.props.e_store_shipment_method_list.push(JSON.parse(JSON.stringify(eStoreShipmentMethodProp)))

    state.props.e_store_shipment_method_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeEStoreGeneralSettingRow = (state, payload) => {

    let key = 0

    state.props.e_store_shipment_method_list.splice(payload, 1)

    if(state.props.e_store_shipment_method_list.length === 0) {
        state.props.e_store_shipment_method_list = [JSON.parse(JSON.stringify(eStoreShipmentMethodProp))]
    }

    state.props.e_store_shipment_method_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const addEStoreBrandRow = state => {

    let key = 0
    state.props.e_store_imprint.push(JSON.parse(JSON.stringify(eStoreImprintProp)))

    state.props.e_store_imprint.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeEStoreBrandRow = (state, payload) => {

    let key = 0

    state.props.e_store_imprint.splice(payload, 1)

    if(state.props.e_store_imprint.length === 0) {
        state.props.e_store_imprint = [JSON.parse(JSON.stringify(eStoreImprintProp))]
    }

    state.props.e_store_imprint.forEach(element => {
        element.key = key
        key ++
    })

}

/*export const sortEStoreTopMenuList = (state, payload) => {

    let key = (payload.key)

    if(payload.sort == 1) {
        state.props.e_store_menu_top_list[key].key = payload.key+1
        state.props.e_store_menu_top_list[key+1].key = payload.key         
    } else if(payload.sort == 0) {
        state.props.e_store_menu_top_list[key].key = payload.key-1
        state.props.e_store_menu_top_list[key-1].key = payload.key         
    }

    state.props.e_store_menu_top_list = state.props.e_store_menu_top_list.sort( (a,b) => { 
        var x = a.key < b.key? -1:1; 
        return x; 
    });

}*/

export const addEStoreBottomMenuRow = state => {

    let key = 0
    state.props.e_store_menu_bottom_list.push(JSON.parse(JSON.stringify(eStoreTopProps)))

    state.props.e_store_menu_bottom_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeEStoreBottomMenuRow = (state, payload) => {

    let key = 0

    state.props.e_store_menu_bottom_list.splice(payload, 1)

    if(state.props.e_store_menu_bottom_list.length === 0) {
        state.props.e_store_menu_bottom_list = [JSON.parse(JSON.stringify(eStoreTopProps))]
    }

    state.props.e_store_menu_bottom_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const sortEStoreBottomMenuList = (state, payload) => {

    let key = (payload.key)

    if(payload.sort == 1) {
        state.props.e_store_menu_bottom_list[key].key = payload.key+1
        state.props.e_store_menu_bottom_list[key+1].key = payload.key         
    } else if(payload.sort == 0) {
        state.props.e_store_menu_bottom_list[key].key = payload.key-1
        state.props.e_store_menu_bottom_list[key-1].key = payload.key         
    }

    state.props.e_store_menu_bottom_list = state.props.e_store_menu_bottom_list.sort( (a,b) => { 
        var x = a.key < b.key? -1:1; 
        return x; 
    });

}


export const resetShopData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/shop/mutations.js